import { spacing } from '@lamimed/pantheon';

import * as S from './styles';

export interface StepperProps {
  steps: number;
  currentStep: number;
  marginTop?: keyof typeof spacing;
}

export const Stepper: React.FC<React.PropsWithChildren<StepperProps>> = ({
  children,
  steps,
  currentStep,
  marginTop = 'none',
}) => {
  return (
    <S.StepperWrapper marginTop={marginTop}>
      <S.TextWrapper>{children}</S.TextWrapper>

      <S.StepperIndicator>
        {[...Array(steps)].map((_, index) => (
          <S.StepDot
            key={`stepper-step-${index}`}
            isActive={index <= currentStep - 1}
          />
        ))}
      </S.StepperIndicator>
    </S.StepperWrapper>
  );
};
